module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Spinner is progress indicator spinner. Can be &#39;small&#39; (for uploader) or &#39;big&#39; (for page content loading)</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Spinner/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Spinner/README.md
// module id = 389
// module chunks = 0